import { List, Create, Edit } from "../Components/index";

export default [
    {
        path: "/admin/leave-restriction",
        component: List,
        name: "leave-restriction-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/leave-restriction/:id/edit",
        component: Edit,
        name: "leave-restriction-edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/leave-restriction/create",
        component: Create,
        name: "leave-restriction-create",
        meta: {
            requiresAuth: true,
        },
    },
];
